var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckWebsite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 8,
    fill: "#FCEBE3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.5628 21.2369H16.3125V49.4919H60.5628V21.2369Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 0.456257,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.646 22.1539H17.2295V48.575H59.646V22.1539Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 0.456257,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2373 51.4957C12.2373 53.9068 14.7504 53.9068 15.5654 53.9068H61.31C62.125 53.9068 64.6381 53.9068 64.6381 51.4957V50.9183H12.2373V51.4957Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 0.456257,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6875 51.8354C63.5856 52.4806 63.1102 52.99 61.3103 52.99H15.5657C13.7658 52.99 13.2904 52.4806 13.1885 51.8354H63.6875Z",
    fill: "#02475E",
    stroke: "#02475E",
    strokeWidth: 0.456257,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9092 37.0259L31.8302 39.947C32.4019 40.5186 33.2929 40.619 33.9773 40.1887L47.9671 31.3952",
    stroke: "#F78670",
    strokeWidth: 2.5988,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWebsite);
export default __webpack_public_path__ + "static/media/CheckWebsite.e357e31cdd9ef2584b2e172dd620a58b.svg";
export { ForwardRef as ReactComponent };